import { defineMessages } from 'react-intl-next';

export default defineMessages({
    addedComment: {
        defaultMessage: 'Added comment',
        description: 'Message after adding a comment as request feedback.',
        id: 'cv.feedback.submitted.page.message',
    },
    redirectText: {
        defaultMessage: 'Need something else? Visit the {helpCenterName}',
        description:
            'Message to redirect back to help center after adding a comment. The help center name variable is defined in cv.feedback.submitted.page.redirect.link. This is the text before "<a href="{}">...</a>" from cv.feedback.submitted.page.redirect.message',
        id: 'cv.feedback.submitted.page.redirect.text',
    },
    redirectLink: {
        defaultMessage: 'Help Center',
        description:
            'Link to redirect back to help center after adding a comment. This is the text in "<a href="{}">...</a>" from cv.feedback.submitted.page.redirect.message',
        id: 'cv.feedback.submitted.page.redirect.link',
    },
});
